<template>
  <i v-if="item.uri_id > 0"
    @click.prevent.stop="$emit('toggle')"
    v-show="item.master"
    class="toggle-icon fas"
    :class="icon"></i>
  <i v-else class="toggle-icon fas fa-asterisk"></i>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    item: Object,
    expanded: Boolean,
  },
  computed: {
    icon() {
      return !this.expanded ? 'fa-chevron-right' : 'fa-chevron-down';
    },
  },
});
</script>

<style scoped lang="scss">
  .toggle-icon {
    cursor: pointer;
    padding: 10px;
    color: $blue;
    font-size: 12px;
    margin: 0;
    width: 30px;
  }
</style>
